<nav class="navbar navbar-expand-lg navbar-dark bg-primary" style="border-bottom: 1px solid #c07373;">
	<div class="row g-1" style="display: flex; width: 100%;padding: 0px 26px;">

		<div class="col-6 col-md-1">
			<div style="display: flex; align-items: center; justify-content: center;">
				<div><a href="#"><img style="height: 50px;" src="https://delta.mycapx.com/assets/images/mycapx_cappy.png"></a></div>
				<div><a href="#"><img style="height: 50px;" src="https://delta.mycapx.com/assets/images/mcxLogo.png"></a></div>

			</div>

		</div>
		<div class="col-5 col-md-8" style="position: relative; overflow:hidden;display: flex; align-items: center;">
			<div style="font-size: 24px;opacity: .1;margin-top: -12px;position: absolute; letter-spacing: .3em;color: #FFF;margin-left: 10px;font-weight: 100;text-transform: uppercase;padding: 0px 12px;">
				{{ string_data['TenantPortal'][language] }}
			</div>
			<div class="burningOrgange" style="font-size: .9rem;; letter-spacing: .3em;color: #FFF;margin-left: 10px;font-weight: 100;text-transform: uppercase;padding: 0px 12px;">
				{{ string_data['TenantPortal'][language] }}
			</div>
		</div>
		
		<div class="col-1 col-md-3" style="display: flex;align-items: anchor-center;">
			<div class="mobileMenuToggle" (click)="menuOpen = !menuOpen" style="text-align: right; color: #FFF; cursor: pointer" >
				<i class="fa fa-bars" style="font-size: 2em;" aria-hidden="true"></i>
			</div>
		</div>

	</div>
</nav>

<div class="mainContentWindow" style="display: flex; flex-direction: row; align-items: top; min-height: calc(100vh - 80px);">
	<div  *ngIf="userService.currentTennant().Tenant_id > 0"  [ngClass]=" menuOpen ? 'menuOpen':'menuClosed'">
		<app-user-info></app-user-info>
	</div>
	<div class="site_content" [ngClass]=" menuOpen ? 'mainContent':'mainContentWithNav'">
		<router-outlet></router-outlet>
	</div>
</div>
	

<div>
	<app-ng-modal #NG_MODAL>	</app-ng-modal>
</div>